//#region frontend/lib/utils.js
function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`
		}
	};
}
function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}
function formatPrice(cents) {
	return new Intl.NumberFormat(document.documentElement.lang || "en", {
		style: "currency",
		currency: window.Shopify?.currency?.active || "USD",
		minimumFractionDigits: 2,
		maximumFractionDigits: 2
	}).format(cents / 100);
}
function formatPriceWithoutTrailingZeros(cents) {
	const fractionDigits = cents % 100 === 0 ? 0 : 2;
	return new Intl.NumberFormat(document.documentElement.lang || "en", {
		style: "currency",
		currency: window.Shopify?.currency?.active || "USD",
		minimumFractionDigits: fractionDigits,
		maximumFractionDigits: 2
	}).format(cents / 100);
}
function getSectionHTML(html, selector = ".shopify-section") {
	return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
}
var BREAKPOINTS = {
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1536
};
function scrollAnimationsDisabled() {
	return document.documentElement.dataset.scrollAnimations === "off";
}
function matchesBreakpoint(value) {
	if (!value) return true;
	if (value.startsWith("max:")) {
		const key = value.slice(4);
		const px = BREAKPOINTS[key] ?? parseInt(key, 10);
		return window.matchMedia(`(max-width: ${px - 1}px)`).matches;
	}
	const px = BREAKPOINTS[value] ?? parseInt(value, 10);
	return window.matchMedia(`(min-width: ${px}px)`).matches;
}
function getEnterDirection(event, element) {
	const rect = element.getBoundingClientRect();
	return event.clientX >= rect.left + rect.width / 2 ? "right" : "left";
}
function getLeaveDirection(event, element) {
	const rect = element.getBoundingClientRect();
	const dx = (event.clientX - rect.left - rect.width / 2) / (rect.width / 2);
	const dy = (event.clientY - rect.top - rect.height / 2) / (rect.height / 2);
	return dy > 0 && Math.abs(dy) > Math.abs(dx) ? "bottom" : dx >= 0 ? "right" : "left";
}
var ALL_BORDER_CLASSES = [
	"border-enter-left",
	"border-enter-right",
	"border-leave-left",
	"border-leave-right",
	"border-leave-bottom"
];
//#endregion
export { formatPriceWithoutTrailingZeros as a, getSectionHTML as c, formatPrice as i, matchesBreakpoint as l, debounce as n, getEnterDirection as o, fetchConfig as r, getLeaveDirection as s, ALL_BORDER_CLASSES as t, scrollAnimationsDisabled as u };
